import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NavaidDTOCalculation, NavaidModel } from 'src/app/models/navaid';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { HttpClient } from '@angular/common/http';
import { WietzeToolDTO } from 'src/app/models/WietzeToolDTO';
import { coverageDTO } from 'src/app/models/coverageDTO';
import { CalculationSettingsModel, RNAVModel } from 'src/app/models/configuration';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { PointsService } from 'src/app/services/points.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ValidationModalService } from 'src/app/services/validation-modal.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { WietzeToolCalcResults } from 'src/app/models/WietzeToolCalcResults';
import { AeroDataConfigProcessingTool, EDS300Config, FligthInspectionConfig, WietzeToolConfig } from 'src/app/models/FligthInspectionConfig';
import { WietzeToolRowInfo } from 'src/app/models/WietzeToolRowInfo';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { CalculationsService } from 'src/app/services/calculations.service';
import { CalculationProgressModel } from 'src/app/models/calculationProgressModel';
import { ProgressService } from 'src/app/services/progress.service';
import { AntennaModel } from 'src/app/models/antennaModel';
import { SelectAntennaPatternService } from 'src/app/services/select-antenna-pattern.service';
import { NavaidTypes } from 'src/app/models/EnumTypes';
import { ProjectService } from 'src/app/services/project.service';

@Component({
  selector: 'app-processing-tool-options',
  templateUrl: './processing-tool-options.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class ProcessingToolOptionsComponent implements OnInit {

  frequency: string;
  cableLoss: number = 0;
  declaredEIRP: number;
  verticalReference:string = "AMSL";
  thresholdSL:number = -89;
  altitudeIncrement:number = 1500;

  @Input() layerName: string;
  @Input() navaid: NavaidModel;
  @Input()
  file: File;
  @Input() fileName: string;
  @Input() importConfig: any;
  @Input() defaultConfig: any;
  @Input()
  fileFormat: string;
  coverageDTO : coverageDTO;

  antennaModels: AntennaModel[];

  constructor(public bsModalRef : BsModalRef,
    public http: HttpClient,
    public endpointService: EndpointsService,
    public configurationService : ConfigurationService,
    private pointsController : PointsService,
    private utilsService: UtilsService,
    private validationModalService: ValidationModalService,
    private modalConfirmation: ModalConfirmationService,
    private modalService: ModalControlService,
    private uiBlock: UiBlockService,
    private calculationService: CalculationsService,
    private progressService: ProgressService,
    private antennaPatternService: SelectAntennaPatternService,
    private projectService: ProjectService
  ) { }

  async ngOnInit() {
    //this.antennaModels = await this.antennaPatternService.getAllAntennaModels();
  }

  cancel(){
    this.bsModalRef.hide();
  }

  ok(){
    this.bsModalRef.hide();
    const formData: FormData = new FormData();
    formData.append('file', this.file, this.fileName);
    formData.append('config', JSON.stringify(this.importConfig));
    formData.append('defaultConfig', JSON.stringify(this.defaultConfig));
    formData.append('thresholdSL', this.thresholdSL.toString());
    formData.append('altitudeIncrement', this.altitudeIncrement.toString());
    formData.append('verticalReference', this.verticalReference);
    formData.append('navaid', JSON.stringify(this.navaid));
    formData.append('coverageDTO', JSON.stringify(this.getCoverageDTO()));
    formData.append('layerName', this.layerName);

    // if (this.navaid.navaidtype == NavaidTypes.DME || this.navaid.navaidtype == NavaidTypes.VOR_DME){
    //   formData.append('antennaModel', this.antennaModels[0].modelName);
    // } else if (this.navaid.navaidtype == NavaidTypes.TACAN || this.navaid.navaidtype == NavaidTypes.VORTAC){
    //   formData.append('antennaModel', this.antennaModels[1].modelName);
    // }

    const projectId = this.projectService.activeProject.id;
    this.http.post(
      this.endpointService.endpointImportProcessingToolFirstStage + "/" + this.fileFormat,
      formData,
      {
        ...this.endpointService.httpOptions,
        params: { projectId: projectId }
      }
    ).subscribe({
      next: (processingToolId: number) => {
        this.http.post(
          this.endpointService.calculateCoverageForProcessingToolSecondStage,
          processingToolId,
          this.endpointService.jsonHttpOptions
        ).subscribe({
          next: () => {},
          error: (error) => {
            console.error(error);
            this.modalService.showMesssageModal(
              'Error Importing Processing Tool',
              'There was an error starting the processing tool calculation.'
            );
          }
        });
      },
      error: (error) => {
        if (error && error.status == 504) {
          return;
        }
        if (error && error.status == 401) {
          this.modalService.showMesssageModal(
            'Error Importing Processing Tool',
            'Default Project is not editable.'
          )
          return;
        }
        if (error && error.status == 400) {
          this.modalService.showMesssageModal(
            'Error Importing Processing Tool',
            `There was an error parsing the file. Please make sure you are importing the correct ${this.fileFormat} file.`
          )
          return;
        }
      }
    })
  }

  getCoverageDTO(){
    const calcSetting : CalculationSettingsModel = CalculationSettingsModel.mapToCalculation(this.configurationService.currentConfiguration);
    const rnav : RNAVModel = RNAVModel.mapToCalculation(this.configurationService.currentConfiguration.rnav);
    const toReturn = new coverageDTO();
    toReturn.useFSPL = true;
    toReturn.isCoverageAssessmentTool = false;
    toReturn.altitudeInterval = 0;
    toReturn.name = "Processing Tool";
    toReturn.navaids = [];
    toReturn.calculationSettings = calcSetting;
    toReturn.rnav = rnav;
    toReturn.projectId = this.configurationService.currentConfiguration.projectId;

    return toReturn;
  }

}
